import { render } from "./Sedes.vue?vue&type=template&id=3d766e5c"
const script = {}
script.render = render

export default script